import { ref } from 'vue'
import { sendToLMS } from '@/authentication/api_js'
import type { AnalyticsData } from '@/tracking/analytics/analyticsTracker'
import { EVENT_NAMES } from '@/tracking/analytics/event_names'
import { getAnalyticsTracker } from '@/tracking/analytics/plugin'

export type TrackedClick = {
  eventName: string
  eventData: AnalyticsData
}

export function useOnDemandTrainingLogin(click: TrackedClick) {
  const analytics = getAnalyticsTracker()
  const hasLoginFailed = ref(false)

  async function openOnDemandTraining() {
    analytics.sendEvent(click.eventName, click.eventData)
    try {
      await sendToLMS()
      analytics.sendEvent(EVENT_NAMES.ON_DEMAND_TRAINING.LOGGED_IN)
    } catch (error) {
      analytics.sendEvent(EVENT_NAMES.ON_DEMAND_TRAINING.LOGIN_FAILED)
      console.error('caught error from sendToLMS', error)
      hasLoginFailed.value = true
    }
  }

  return { hasLoginFailed, openOnDemandTraining }
}
